import { Navigate, generatePath } from 'react-router-dom';

import { NBA_PLAY_EVENTTYPE } from '@sorare/core/src/constants/__generated__/routes';

import { useLastVisitedEventType } from '@sorare/gameplay/src/hooks/useLastVisitedEventType';

export const NBAPlayPage = () => {
  const { lastVisitedEventType } = useLastVisitedEventType();

  return (
    <Navigate
      to={generatePath(NBA_PLAY_EVENTTYPE, {
        eventType: lastVisitedEventType,
      })}
      replace
    />
  );
};

export default NBAPlayPage;
